import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, freddyTheme } from '@coolblue-development/freddy';
import styled from '@emotion/styled';
export const StyledBox = ({ children, id, variant, dropdownSizeValue, }) => {
    const Styled = styled(Box) `
    ${({ theme }) => `
      position: ${variant === 'default' ? 'absolute' : 'relative'};
      z-index: 6;
      width: 100%;
      box-shadow: ${variant === 'default' ? theme.shadow.subtle : 'initial'};
      overflow-y: auto;
      border-radius: ${theme.borderRadius[100]};
      max-height: ${variant === 'default' ? (dropdownSizeValue === 'extended' ? '470px' : '400px') : 'initial'};

      div label {
        display: flex !important;
        box-shadow: none;
        background: ${theme.color.background.base};
        box-sizing: border-box;
        padding: ${theme.spacing[400]};

        ${variant === 'default' &&
        `
          border-top-color: ${theme.color.border.interactiveFocusedInner};
          border-radius: initial;
        `}
      }

      div:not(:last-child) label {
        ${variant === 'contentOnly' &&
        `
          margin-bottom: ${theme.spacing[200]};
        `}
      }

      div input:checked + label {
        border-top: ${theme.borderWidth[50]} solid
          ${theme.color.border.interactiveSelected};
        background: ${theme.color.background.interactiveSelected};
        padding-top: 15px;
        padding-bottom: 15px;

        ${variant === 'default' &&
        `
          margin: initial;
        `}
      }

      div input:not(:checked) + label {
        border-left: ${variant === 'default'
        ? `${theme.borderWidth[50]} solid ${theme.color.border.interactiveFocusedInner}`
        : `${theme.borderWidth[25]} solid ${theme.color.border.base}`};
        border-right: ${variant === 'default'
        ? `${theme.borderWidth[50]} solid ${theme.color.border.interactiveFocusedInner}`
        : `${theme.borderWidth[25]} solid ${theme.color.border.base}`};

        ${variant === 'contentOnly' &&
        `
          padding-left: 17px !important;
          padding-right: 17px !important;
        `}
      }

      div:first-of-type input:not(:checked) + label {
        border-top: ${variant === 'default'
        ? `${theme.borderWidth[50]} solid ${theme.color.border.interactiveFocusedInner}`
        : `${theme.borderWidth[25]} solid ${theme.color.border.base}`};
        ${variant === 'default' &&
        `
          padding-top: 15px;
        `}

        ${variant === 'contentOnly' &&
        `
          padding-top: ${theme.spacing[400]};
        `}
      }

      div:last-of-type input:not(:checked) + label {
        border-bottom: ${variant === 'default'
        ? `${theme.borderWidth[50]} solid ${theme.color.border.interactiveFocusedInner}`
        : `${theme.borderWidth[25]} solid ${theme.color.border.base}`};
      }

      div input:not(:checked) + label:hover {
        box-shadow: initial !important;
        background: ${theme.color.background.interactiveSelected};
        ${variant === 'default' &&
        `
          border-top-color: ${theme.color.background.interactiveSelected};
          border-left-color: ${theme.color.background.interactiveSelected};
          border-right-color: ${theme.color.background.interactiveSelected};
          `}
      }

      div:last-of-type input:not(:checked) + label:hover {
        ${variant === 'default' &&
        `
          border-bottom-color: ${theme.color.background.interactiveSelected};
        `}
      }
    `}
  `;
    return (_jsx(Styled, { id: id, variant: variant, children: children }));
};
export const StyledButton = ({ children, onClick, ariaExpanded, ariaControls, endIcon, }) => {
    const Styled = styled(Button) `
    border: ${freddyTheme.borderWidth[25]} solid;
    border-color: ${ariaExpanded
        ? freddyTheme.color.border.interactiveHovered
        : freddyTheme.color.border.interactiveBase};
    border-radius: ${freddyTheme.borderRadius[100]};
    background: initial;
    box-shadow: initial;
    color: initial;
    font-weight: initial;
    height: ${freddyTheme.spacing[1000]};
    width: 100%;
    text-align: left;
    justify-content: space-between;
    align-items: center;

    svg {
      min-width: ${freddyTheme.spacing[300]};
    }

    &:hover,
    &:active {
      background: initial;
      box-shadow: initial;
      border-color: ${freddyTheme.color.border.interactiveHovered};
    }
  `;
    return (_jsx(Styled, { onClick: onClick, "aria-expanded": ariaExpanded, "aria-controls": ariaControls, endIcon: endIcon, children: children }));
};
export const Backdrop = styled(Box) `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5;
`;
//# sourceMappingURL=CollectionDropdown.styled.js.map